import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import App from './App'
import Error from './404'
import React from 'react'
import { contentPath, modules } from './config/pages'
import Forbidden from './pages/Forbidden'

// WPBOT Pages
import ViewBots from './pages/bots/ViewBots'
import CreateBot from './pages/bots/CreateBot'
import BotDetail from './pages/bots/BotDetail'
import ViewTools from './pages/bots/ViewTools'
import ViewContacts from './pages/bots/ViewContacts'
import ViewChats from './pages/bots/ViewChats'

function Routes(){
  return (
    
    <Router>
      <Switch>
        <Route exact path="/" component={App}/> 
        <Route exact path="/sorry" component={Forbidden}/> 

        {/* WPBOT */}
        <Route exact path={contentPath[modules.BotList]} component={ViewBots}/>  
        <Route exact path={contentPath[modules.BotCreate]} component={CreateBot}/>  
        <Route exact path={contentPath[modules.BotDetail]} component={BotDetail}/>  
        <Route exact path={contentPath[modules.ToolList]} component={ViewTools}/>  
        <Route exact path={contentPath[modules.ContactList]} component={ViewContacts}/>  
        <Route exact path={contentPath[modules.ChatList]} component={ViewChats}/>  

        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default Routes
